export function findLinksBySignalID(correlations, signalID) {
    let links = [];
    correlations.forEach((_correlation) => {
        links = links.concat(_correlation.link.filter((_link) => _link.signal.id === signalID));
    });
    return links;
}
//# sourceMappingURL=findLinksBySignalID.js.map